module.exports = __webpack_public_path__ + "static/image/service/pc/cartoon.jpg?de798e5a";